

waitFor_jQuery(function() {

  jQuery(document).ready(function() {

    var navClickPolice = false;

    $(window).scroll(function() {
      inViewport();
    });

    $(window).resize(function() {
      inViewport();
    });

    function inViewport() {
      $('.sectiontype1.space-bottom.animation-img').each(function() {
        var divPos = $(this).offset().top,
          topOfWindow = $(window).scrollTop();
        if (divPos < topOfWindow + 400) {
          $(this).addClass('loaded onscreen');
        }
      });
    }


    $('.hero-section.animation-img').addClass('loaded onscreen');


    if ($(window).width() >= 991) {
      // $(".shop-sub-menu").mCustomScrollbar({
      //   autoHideScrollbar: true
      // });
    }
    $('.site-nav--has-dropdown').click(function() {
      $(this).toggleClass('submenu-open')
    });
    $('.shop-sub-menu li h3').click(function() {
      //    console.log('222222222')
      $(this).parent().toggleClass('submenu-open')
      $(this).parent().parent().toggleClass('ul-submenu-open')
    });

    $('body').on('click', '.shop-menu', function() {
      $(this).toggleClass('open');
      $('header').toggleClass('shop-open');
      $('body').toggleClass('shop-menu-overlay');
      // setTimeout(function () {
      //   $(".shop-sub-menu").mCustomScrollbar("update");
      // },1000)
      // openDskNav()
    });
    var actMod = 'locked';

    function openDskNav() {
      if ($('body').is('.' + actMod)) {
        unlockBody()
      } else {
        lockBody()
      }
      // $('.nav-menu, .menu-toggle, header.header').toggleClass('open');
      $('body').toggleClass('dsk-nav-open');
      navClickPolice = true;
      setTimeout(function() { navClickPolice = false; }, 500);
    }
    if ($(window).width() >= 991) {
      $(document).click(function(e) {
        if (!$(e.target).is('.shop-menu *')) {
          $(".shop-menu").removeClass('open');
          $('header').removeClass('shop-open');
          $('body').removeClass('shop-menu-overlay')
          // openDskNav()
        }
      });
    }
    //play audio onclick
    //   $("body").on("click", ".play-audio", function() {
    //     var url = $(this).data("audio_url");
    //     var src = 'https://w.soundcloud.com/player/?url='+url+'&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true';
    //     var audioElement = document.getElementById('audio');
    //     audioElement.setAttribute('src', src);
    //     // Load src of the audio file
    // //     audioElement.load();
    //   });
    //play iframe video on click
    //   $("body").on("click", ".play-video", function() {
    //     var src = $(this).data("video_url");
    //     console.log(src);
    //     var videoElement = document.getElementById('video');
    //     videoElement.setAttribute('src', src);
    //   });




    $('.services-slider').slick({
      centerMode: true,
      centerPadding: '70px',
      variableWidth: true,
      slidesToShow: 3,
      prevArrow: '<button class="product-prev"></button>',
      nextArrow: '<button class="product-next"></button>',

      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerPadding: '0',
          arrows: true,
          prevArrow: '<button class="product-prev"> </button>',
          nextArrow: '<button class="product-next"> </button>',


        }
      }],

    });



    $('.share-icon').click(function() {
      $('.social-shares-section').toggle();
    });

    $('#header').load('header.html');
    $('#footer').load('footer.html');
    /*Mobile toggle*/
    $('#menu-toggle').on('click', function(event) {
      $(".header").toggleClass("header-open");
      //     console.log(112)
    });
    // $('body').on('click', '.menu-toggle', function(event) {
    //   openMobNav()
    // });
    // if($(window).width() < 991) {
    //   $(document).click(function(e) {
    //     if ( $('.nav-menu.open').length > 0 && !$(e.target).is('.nav-menu.open *') && !navClickPolice) {
    //       openMobNav()
    //     }
    //   });
    // }
    function openMobNav() {
      if ($('body').is('.' + actMod)) {
        unlockBody()
      } else {
        lockBody()
      }
      $('.nav-menu, .menu-toggle, header.header').toggleClass('open');
      $('body').toggleClass('mob-nav-open');
      navClickPolice = true;
      setTimeout(function() { navClickPolice = false; }, 500);
    }

    function lockBody() {
      var lastTop = $(window).scrollTop();
      $('body').addClass(actMod).css({ top: -lastTop });
    }

    function unlockBody(el) {
      var lastTop = Math.abs(parseInt($('body').css('top')));
      $('body').css({ top: 0 }).removeClass(actMod);
      window.scrollTo(0, lastTop);
    }




    $('body').on('click', '.discover-menu a', function(event) {
      $('.discover-menu').addClass('open');
    });
    $('body').on('click', '.menu-toggle-discover', function(event) {
      //     console.log(123);
      if ($('.discover-menu').hasClass('open')) {
        $('.discover-menu').removeClass('open');
      }
    });
    $('.page-scroll').on('click', function(event) {
      var $anchor = $(this);
      $('html, body').stop().animate({
        scrollTop: $($anchor.attr('href')).offset().top
      }, 1000, 'easeInOutExpo');
      event.preventDefault();
    });

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $("body").addClass("header-sticky");
      } else {
        $("body").removeClass("header-sticky");
      }
    });
    $(".flip").click(function() {
      $(".panel").slideToggle("slow");
    });

    /* $(".home-slider").slick({
      infinite: true,
      autoplay: true,   
      slidesToShow:1,
      slidesToScroll:1,
      dots:false,
      speed: 1000,
    });*/
    var $status = $('.custom-pagination');
    var $slickElement = $('.best-seller-slider-image');
    $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });
    $(".best-seller-slider-image").slick({
      infinite: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      speed: 900,
      autoplaySpeed: 3000,
      appendArrows: $(".small-arrow"),
      prevArrow: '<button class="product-prev"></button>',
      nextArrow: '<button class="product-next"></button>',
      asNavFor: '.best-seller-slider-content',
    });
    $(".pdp.image-container").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      speed: 900,

    });
    $(".best-seller-slider-content").slick({
      infinite: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplaySpeed: 3000,
      arrows: false,
      asNavFor: '.best-seller-slider-image',
    });

    function move_next() {
      $(".thumbnail-slider-left").slick('slickNext');
      $(".thumbnail-slider-middle").slick('slickNext');
      //$(".thumbnail-slider-right").slick('slickNext');
    }

    function move_prev() {
      //$(".thumbnail-slider-left").slick('slickPrev');
      $(".thumbnail-slider-middle").slick('slickPrev');
      $(".thumbnail-slider-right").slick('slickPrev');
    }

    $('body').on('click', '.custom-next', function() {
      move_next();
    });

    $('body').on('click', '.custom-prev', function() {
      move_prev();
    });

    $(".thumbnail-slider-left").slick({
      initialSlide: 0,
      infinite: true,
      autoplay: false,
      dots: false,
      speed: 1000,
      autoplaySpeed: 3000,
      centerMode: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: $(".product-arrow-left"),
      prevArrow: '<button class="product-prev custom-prev"></button>',
      nextArrow: '<button class="product-next"></button>',
      //asNavFor: '.thumbnail-slider',
    });
    $(".thumbnail-slider-middle").slick({
      initialSlide: 1,
      infinite: true,
      autoplay: false,
      dots: false,
      speed: 1000,
      autoplaySpeed: 3000,
      centerMode: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      //asNavFor: '.thumbnail-slider',
      responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: true,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: true,
          }
        }
      ]
    });
    $(".thumbnail-slider-right").slick({
      initialSlide: 2,
      infinite: true,
      autoplay: false,
      dots: false,
      speed: 1000,
      autoplaySpeed: 3000,
      centerMode: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: $(".product-arrow-right"),
      appendArrows: $(".product-arrow-right"),
      prevArrow: '<button class="product-prev"></button>',
      nextArrow: '<button class="product-next custom-next"></button>',
      //asNavFor: '.thumbnail-slider',  
    });
    $(".home-slider").slick({
      infinite: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      speed: 1000,
      autoplaySpeed: 3000,

    });
    $('.home-slider').on('beforeChange', function(e, slick, currentSlide, nextSlide) {
      var $animatingElements = $('div.slick-slide[data-slick-index="' + nextSlide + '"]');
      $animatingElements.find('.slide-img').removeClass('wow slideInDown');
      $animatingElements.find('.slide-img').removeAttr('data-effect', 'fadeInUp');

      $animatingElements.find('.slide-img').addClass('wow slideInDown');
      $animatingElements.find('.slide-img').attr('data-effect', 'fadeInUp');

      $animatingElements.find('h1').addClass('wow slideInRight');
      $animatingElements.find('h1').attr('data-effect', 'fadeInUp');

      $animatingElements.find('p').addClass('wow slideInRight');
      $animatingElements.find('p').attr('data-effect', 'fadeInUp');

      $animatingElements.find('span').addClass('wow slideInLeft');
      $animatingElements.find('span').attr('data-effect', 'fadeInUp');

    });

    jQuery('img.svg').each(function() {
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      jQuery.get(imgURL, function(data) {
        var $svg = jQuery(data).find('svg');
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        $svg = $svg.removeAttr('xmlns:a');
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }
        $img.replaceWith($svg);
      }, 'xml');
    });
    $('body').on('click', '.search-icon a', function(event) {
      $('.search-form').addClass('form-open');
    });
    $('body').on('click', '.close-form', function(event) {
      $('.search-form').removeClass('form-open');
    });

    jQuery('img.svg').each(function() {
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      jQuery.get(imgURL, function(data) {
        var $svg = jQuery(data).find('svg');
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        $svg = $svg.removeAttr('xmlns:a');
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }
        $img.replaceWith($svg);
      }, 'xml');
    });

    function matchheight_content() {
      //blog page content match height
      $('.matchHeight-box').matchHeight({
        byRow: true
      });

      //blog page content match height
      $('.card .product-box h2').matchHeight({
        byRow: true
      });
      //.thumbnail-slider-middle match height
      $('.thumbnail-slider-middle .slider-item-title').matchHeight({
        byRow: true
      });

      $('.thumbnail-slider-left .slider-item-title').matchHeight({
        byRow: true
      });

      $('.thumbnail-slider-right .slider-item-title').matchHeight({
        byRow: true
      });
    }
    matchheight_content();
    jQuery(window).resize(function() {
      matchheight_content();
    });

    // Read MORE
    $('body').on('click', '.read-more', function() {
      $('.short-info').hide();
      $('.long-info').show();
    });

    // Read LESS
    $('body').on('click', '.read-less', function() {
      $('.long-info').hide();
      $('.short-info').show();
    });

    // variation change
    //$('body').on('change', '.single-option-selector', function() {
    /* $('body').on('variationChange', '.single-option-selector', function(var_id) {

      var variation_id = $(this).data('id');

    $('.variation-data').hide();
      $('.variation-data-'+variation_id).show();

    });*/

    //$('#myTab .nav-item').first().click();
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    $('.videoModal').on('hidden.bs.modal', function(e) {
      var _this = this,
        youtubeSrc = $(_this).find("iframe").attr("src");

      $(_this).find("iframe").attr("src", ""); // removing src on runtime to stop video
      $(_this).find("iframe").attr("src", youtubeSrc); // again passing youtube src value to iframe
    });
    $('.audioModal').on('hidden.bs.modal', function(e) {
      if ($(this).find('button').hasClass('playing')) {
        $(this).find('button').trigger('click');
        //       console.log(333);
      }

      var _this = this,
        youtubeSrc = $(_this).find("iframe").attr("src");


      $(_this).find("iframe").attr("src", ""); // removing src on runtime to stop video
      $(_this).find("iframe").attr("src", youtubeSrc); // again passing youtube src value to iframe

    });
  });

  function headerHeight() {
    setTimeout(function() {
      var mainNav = $('header.header nav.navbar'),
        topBar = $('header.header .top-header'),
        mainHght = mainNav.outerHeight(true) + 'px',
        barHght = topBar.outerHeight(true) + 'px';
      document.documentElement.style.setProperty('--banner-height', barHght);
      if (mainNav.not('.open')) {
        document.documentElement.style.setProperty('--header-height', mainHght);
      }
    }, 1000)
  }
  headerHeight()
  $(document).ready(function() {
    headerHeight()
    setTimeout(function() {
      headerHeight()
    }, 1000)
  })
  $(window).on('resize', function() {
    headerHeight()
  })
  $(document).on('scroll', function() {
    headerHeight()
  })








  // Accordian
  $(document).on('touch click', '.acc-btn', function() {
    var btn = '.acc-btn',
      animTime = 300,
      justClicked = false,
      active = 'selected',
      cont = '.acc-content',
      ttlTxt = 'h3',
      imgItm = '.img',
      clckdIndx = $(this).index(btn),
      inrChldHght = $(cont).children().eq(clckdIndx).outerHeight(true),
      $thsTtl = $(this).find(ttlTxt),
      $thsImg = $(this).find(imgItm),
      isOpen = $thsTtl.hasClass(active),
      winWidth = $(window).width(),
      clearItem = $('header.header');


    if (!justClicked) {
      justClicked = true;
      if (isOpen) {
        removeClasses();
        openClose();
      } else {
        removeClasses();
        addClasses();
        openClose(true);
        mobScroll();
      }
      setTimeout(function() { justClicked = false; }, animTime);
    }

    function mobScroll() {
      if (winWidth < 750) {
        setTimeout(function() {
          var actTab = $(ttlTxt + '.' + active),
            clear = clearItem.outerHeight(true) + 30,
            actTabTop = !!actTab ? actTab[0].getBoundingClientRect().top + window.pageYOffset : '';
          if (!!clearItem && !!actTab) {
            actTabTop = actTabTop - clear;
          }
          if (actTabTop != '') {
            $([document.documentElement, document.body]).animate({
              scrollTop: actTabTop
            }, animTime);
          }
        }, animTime * 2.5);
      }
    }

    function removeClasses() {
      $(btn + ' ' + ttlTxt).removeClass(active);
      $(btn + ' ' + imgItm).removeClass(active);
    }

    function addClasses() {
      $thsTtl.addClass(active);
      $thsImg.addClass(active);
    }

    function zeroHght() {
      $(cont).stop().animate({ height: 0 }, animTime);
    }

    function setHght() {
      $(cont).eq(clckdIndx).stop().animate({ height: inrChldHght }, animTime);
    }

    function openClose(dir) {
      if (dir == 'open' || dir == true) {
        zeroHght()
        setHght()
      } else {
        setHght()
        zeroHght()
      }
    }
  });


  function positionChange(item, mob, desk, scrn, ba) {
    item = $(item);
    mob = $(mob);
    desk = $(desk);
    scrnSize = scrn.length < 0 ? 750 : scrn;
    beforeAfter = ba;
    moved = false;
    mob_chk = 'mob';
    desk_chk = 'desk';
    initPos();
    $(window).resize(function() {
      initPos();
    })

    function initPos() {
      wdth = $(window).width();
      chngPos = scrnSize;
      above = wdth > chngPos && moved != desk_chk;
      below = wdth <= chngPos && moved != mob_chk;
      if (above) {
        move(item, desk, beforeAfter);
        moved = desk_chk;
      }
      if (below) {
        move(item, mob, beforeAfter);
        moved = mob_chk;
      }
    }

    function move(el, moveEl, beforeAfter) {
      el = el;
      moveEl = moveEl;
      if (beforeAfter == 'before') {
        $(el).insertBefore(moveEl)
      } else if (beforeAfter == 'after') {
        $(el).insertAfter(moveEl)
      } else {
        $(el).appendTo(moveEl)
      }
    }
  }

  // var moveItem  = '.template-product .move-images',
  //     mobMove   = '.template-product .mobile-image-placement',
  //     deskMove  = '.template-product .desktop-image-placement',
  //     ba = 'after';

  // positionChange( moveItem, mobMove, deskMove, ba);


  function watchForElement(el, method) {
    chkDelay = '200'; // Amount of time between Checks
    var chkExist = setInterval(function() {
      chkClass = $(el);
      if (chkClass.length) {
        // DO something
        clearInterval(chkExist);
        method(chkClass)
      }
    }, chkDelay);
  }
  // var chkEl = '[data-testid="ShopifyPay-button"]';
  // watchForElement(chkEl,function(el) {
  //     el.parent().hide()
  // })


  // var moveItem  = '.template--product .afterpay-paragraph',
  //     mobMove   = '#mobile-afterpay',
  //     deskMove  = '#desktop-afterpay',
  //     scrn      = 991,
  //     ba        = '';

  // watchForElement(moveItem,function(el) {
  //   positionChange( moveItem, mobMove, deskMove, scrn, ba);
  // })

    // New Navigation 
  $(document).ready(function() {
    var mega, drp, prvFxdHdrHght, prevDistFromTop;
    var winWdth = $(window).width(),
      distFromTop = document.documentElement.scrollTop,
      prevdistFromTop = distFromTop,
      mobInit = 990,
      isDesk = winWdth >= mobInit,
      justClicked = false,
      fxdHdr = 'header.header',
      fxdHdrHght = $(fxdHdr).height(),
      mnCntnt = '#MainContent',
      lnk = '.nav-item',
      inrLnk = '.dropdown-link',
      drpDwn = '.dropdown-list',
      nulLnk = 'a[href="#"]',
      megaMenu = '.mega-pane',
      megaDta = 'megamenu',
      drpActive = 'active',
      bdyCls = 'locked',
      inr = 'inner-',
      otrItmDta = 'nav-item',
      inrItmDta = inr + otrItmDta,
      otrDrpDta = 'dropdown',
      inrDrpDta = inr + otrDrpDta,
      mobNav = '.mobile-nav',
      drpDwnStl   = '.use-dropdown',
      openCloseMobNav = '.menu-btn,.close-nav',
      mobNavOpen = 'mobile-nav-open',
      navOpen = 'mobile-nav--open',
      navClose = 'mobile-nav--close',
      mobNavBG = '.mobile-nav-background-close',
      moveAside = '.move-aside',
      mobDrpTggl = '.menu-toggle',
      mobBckTggl = '.reverse',
      lvlOne = 'level-one',
      lvlTwo = 'level-two';

    function clickPolice(justClicked) {
      // console.log('clickPolice')
      // justClicked = true;
      // setTimeout(function() { justClicked = false;
      //   console.log('clicked: ' +justClicked); }, 700);
    }

    initNav(winWdth, mobInit, isDesk, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl,drpDwnStl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt);
    $(window).resize(function() {
      var winWdth = $(window).width(),
        fxdHdrHght = $(fxdHdr).height(),
        isDesk = winWdth >= mobInit;
      initNav(winWdth, mobInit, isDesk, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl,drpDwnStl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt);
    });
    $(window).scroll(function() {
      var winWdth = $(window).width(),
        fxdHdrHght = $(fxdHdr).height(),
        isDesk = winWdth >= mobInit;
      initNav(winWdth, mobInit, isDesk, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl,drpDwnStl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt);
    });

    function initNav(winWdth, mobInit, isDesk, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl,drpDwnStl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt) {

      if (prvFxdHdrHght != fxdHdrHght) {
        $(megaMenu).css({
          top: fxdHdrHght
        });
        var prvFxdHdrHght = fxdHdrHght;
      }
      if (isDesk) {
        $(lnk + ',' + inrLnk).unbind().on('mouseover mouseleave focusin focusout', function(e) {
          if (!justClicked) {
            clickPolice();

            if (e.type == 'mouseover' || e.type == 'focusin') {
              openLinks($(this));
            }
            if (e.type == 'mouseleave') {
              closeLinks($(this));
            }
            if (e.type == 'focusout') {
              fcsChkr($(this));
            }
          }
        });
        $(megaMenu + ',' + drpDwn).unbind().on('mouseleave focusout', function(e) {
          if (!justClicked) {
            clickPolice();

            if (e.type == 'mouseleave' && $(this).is(megaMenu)) {
              closeMega($(this));
            }
            if (e.type == 'focusout' && $(this).is(megaMenu)) {
              fcsChkr($(this));
            }
            if (e.type == 'mouseleave' && $(this).is(drpDwn)) {
              closeLinks($(this));
            }
          }
        });
      } else {
        $(mobDrpTggl + ',' + lnk + ' ' + nulLnk + ',' + inrLnk + ' ' + nulLnk).unbind().on('touch click', function(e) {
          if (!justClicked) {
            clickPolice();


            // If arrow click
            if ($(this).is(mobDrpTggl)) {
              ths = $(this);
            }
            // if null link ('#' as href)
            if ($(this).is(nulLnk)) {
              e.preventDefault();
              ths = $(this).parent().children(mobDrpTggl);
            }
            openMobLnk(ths);
          }
        });
        $(openCloseMobNav + ',' + mobNavBG).unbind().on('touch click', function(e) {
          e.preventDefault();
          if (!justClicked) {
            clickPolice();

            toggleMobNav();
          }
        });
      }

    }

    function openLinks(el) {
      var $thsLnk = $(el),
        isAct = $thsLnk.is('.' + drpActive),
        otrData = $thsLnk.data(otrItmDta),
        inrData = $thsLnk.data(inrItmDta);
      if (!!otrData || !!inrData) {
        closeLinks($thsLnk);
      }
      if (!isAct) {
        $thsLnk.addClass(drpActive);
        // Activate Megamenu
        var mega = $('[data-' + megaDta + '="' + otrData + '"]');
        if (!!mega) {
          fxdHdrHght = $(fxdHdr).height();
          mega.css({
            top: fxdHdrHght
          }).addClass(drpActive);
        }
      }
    }

    function closeLinks(el) {
      var $thsLnk = $(el),
        otrData = $thsLnk.data(otrItmDta),
        inrAct = $thsLnk.is('.' + drpActive),
        megaAct = $('[data-' + megaDta + '="' + otrData + '"]').is('.' + drpActive);
      if (!megaAct && !inrAct) {
        $(drpDwn + ',' + megaMenu + ',' + lnk + ',' + inrLnk).removeClass(drpActive);
      }
    }

    function closeMega(el) {
      $(drpDwn + ',' + megaMenu).removeClass(drpActive);
      $(lnk).removeClass(drpActive);
    }

    function toggleMobNav(el) {
      var isAct = $(mobNav).is('.' + drpActive);
      if (!isAct) {
        // // make nav active
        $(mobNav + ',' + mobNavBG).addClass(drpActive);
        $(openCloseMobNav).addClass(navClose).removeClass(navOpen);
        $('body').css({'top': -Math.abs(document.documentElement.scrollTop) + 'px'}).addClass(bdyCls);
        $(fxdHdr).addClass(mobNavOpen);
      } else {
        $(openCloseMobNav).removeClass(navClose).addClass(navOpen);
        // remove active from menu and bg-overlay/close
        $(mobNav + ',' + mobNavBG).removeClass(drpActive);
        // remove all active classes to reset menu
        $(mobNav + ' .' + drpActive).removeClass(drpActive);
        // remove level classes from the move aside element
        $(moveAside).removeClass(lvlOne).removeClass(lvlTwo);
        $('body').removeClass(bdyCls);
        $(fxdHdr).removeClass(mobNavOpen);
        window.scrollTop = prevDistFromTop;
      }
      var prevDistFromTop = distFromTop;
    }

    function openMobLnk(el) {
      var $thsLnk = $(el),
        isDrpTggl = $thsLnk.is(mobDrpTggl),
        isBckTggl = $thsLnk.is(mobBckTggl),
        $thsPar = $thsLnk.parent(),
        isDropStyle = $thsLnk.closest(drpDwnStl).length > 0,
        isAct = $thsPar.is('.' + drpActive),
        moveLvlOne = $(moveAside).is('.' + lvlOne),
        moveLvlTwo = $(moveAside).is('.' + lvlTwo);
      
      if ( !isDropStyle ) {    
        // Move to Second Level
        if (!moveLvlOne && $thsPar.is(lnk)) {
          remActive($thsPar);
          addActive($thsPar);
          togLvl(moveAside, lvlOne);
        }
        // Move to Third level
        if (!moveLvlTwo && $thsPar.is(inrLnk)) {
          remActive($thsPar);
          addActive($thsPar);
          togLvl(moveAside, lvlTwo);
        }
        // Move back to Second level
        if (moveLvlTwo && moveLvlOne && isBckTggl) {
          togLvl(moveAside, lvlTwo);
          remActive($thsPar);
        }
        // Move back to First level
        else if (moveLvlOne && isBckTggl) {
          togLvl(moveAside, lvlOne);
          remActive($thsPar);
        }
      }

      // Drop Style
      if ( isDropStyle ) {
        if (isAct) {
          closeHeights($thsPar)
        } else {
          if ( $thsPar.is(lnk) ) {
            $(lnk+','+inrLnk).each(function () {
              closeHeights($(this))
            })
          }
          if ( $thsPar.is(inrLnk) ) {
            $(inrLnk).each(function () {
              closeHeights($(this))
            })
          }
          openHeight($thsPar)
        }
      }

      function closeHeights(el) {
        var el = el;
        el.removeClass(drpActive)
      }
      function openHeight(el) {
        var el = el;
        el.addClass(drpActive)
      }
      
      function remActive(el) {
        setTimeout(function() {
          $thsPar.parent().children().removeClass(drpActive);
        }, 200)
      }

      function addActive(el) {
        setTimeout(function() {
          $thsPar.addClass(drpActive);
        }, 200)
      }

      function togLvl(el, cls) {
        setTimeout(function() {
          if ($(el).is('.' + cls)) {
            $(el).removeClass(cls);
          } else {
            $(el).addClass(cls);
          }
        }, 200)
      }
    }

    function fcsChkr(el) {
      var $thsLnk = $(el);
      checker = setTimeout(function() {
        if (!$thsLnk.find(':focus').length) {
          closeLinks($thsLnk);
        }
      }, 0);
      clearTimeout(checker);
    }

  });

});




// timer start desktop
jQuery(document).ready(function() {

  // Newly added code start
  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) { s = "0" + s; }
    return s;
  }
  // Newly added code end

  var windowWidth = $(window).width();
  var isMobile = windowWidth <= 991;

  var sec_circle = document.querySelector(isMobile ? '.sec__circle2' : '.sec__circle');
  var min_circle = document.querySelector(isMobile ? '.min__circle2' : '.min__circle');
  var hour_circle = document.querySelector(isMobile ? '.hour__circle2' : '.hour__circle');
  if ($(".sec__circle2").is(":visible") == true) {
    var sec_radius = sec_circle.r.baseVal.value;
    var min_radius = min_circle.r.baseVal.value;
    var hour_radius = hour_circle.r.baseVal.value;

    var sec_circumference = sec_radius * 2 * Math.PI;
    var min_circumference = min_radius * 2 * Math.PI;
    var hour_circumference = hour_radius * 2 * Math.PI;


    sec_circle.style.strokeDasharray = `${sec_circumference} ${sec_circumference}`;
    sec_circle.style.strokeDashoffset = `${sec_circumference}`;

    min_circle.style.strokeDasharray = `${min_circumference} ${min_circumference}`;
    min_circle.style.strokeDashoffset = `${min_circumference}`;

    hour_circle.style.strokeDasharray = `${hour_circumference} ${hour_circumference}`;
    hour_circle.style.strokeDashoffset = `${hour_circumference}`;


    // timer start
    function setSecProgress(percent) {
      const offset = sec_circumference - percent / 100 * sec_circumference;
      sec_circle.style.strokeDashoffset = offset;
    }

    function setMinProgress(percent) {
      const offset = min_circumference - percent / 100 * min_circumference;
      min_circle.style.strokeDashoffset = offset;
    }

    function setHourProgress(percent) {
      const offset = hour_circumference - percent / 100 * hour_circumference;
      hour_circle.style.strokeDashoffset = offset;
    }
  }

  // console.log('in js');
  var countDownDate = (theme.black_friday_end_date) * 1000;
  // console.log('countDownDate', countDownDate);
  var now = new Date().getTime();
  var distance = countDownDate - now;
  // console.log('distance', distance);

  var msec = 1; // newly added
  var sec_timer = null; // newly added
  var x = null;
  var flag = false;
  var percentage = 100;
  var showStripe = false;
  if (distance > 0) {
    $('.banner-home-timer').removeClass('hide');
    $('.banner-home, .offer-end-wrap').addClass('hide');
    // console.log('inside counter');
    window.onfocus = function() {
      if (sec_timer) {
        clearInterval(sec_timer);
        sec_timer = null;
      }
      setSecProgress(percentage);
    };
    document.addEventListener('visibilitychange', function(ev) {
      if (document.visibilityState === 'hidden') {
        clearInterval(sec_timer);
        sec_timer = null;
      }
      setSecProgress(percentage);
    });
    x = setInterval(function() {
      // Get today's date and time
      var now = new Date().getTime();
      // Find the distance between now and the count down date
      distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 48)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      // var mseconds = Math.floor((distance / 1000).toFixed(3));

      // Display the result in the element with id="demo"
      if ($("#timer").is(":visible") == true)
        document.getElementById("timer").innerHTML = hours.pad() + ":" +
        minutes.pad() + ":" + seconds.pad();

      if ($("#mobile_timer").is(":visible") == true)
        document.getElementById("mobile_timer").innerHTML = hours.pad() + ":" +
        minutes.pad() + ":" + seconds.pad();

      // newly added code start
      if (!sec_timer) {
        msec = seconds * 1000;
        sec_timer = setInterval(function() {
          percentage = ((msec) / (60 * 1000)) * 100;
          setSecProgress(percentage)
          msec -= 100;
        }, 100)
      }
      if (seconds === 0) {
        clearInterval(sec_timer);
        sec_timer = null;
      }

      setMinProgress(((minutes) / (60)) * 100);
      setHourProgress(((hours) / (48)) * 100);
      // If the count down is finished, write some text

      if (distance < 0) {
        // console.log('---in inside if', flag);
        clearInterval(sec_timer);
        sec_timer = null;
        clearInterval(x);
        x = null;
        //           $('.sec__circle, .min__circle, .hour__circle, #timer').addClass('hide');
        document.getElementById("timer").innerHTML = "OFFER STARTED";
        window.location.reload();
        flag = true;
      }
    }, 1000);
  } else {
    $('.banner-home-timer').addClass('hide');
    $('.banner-home').removeClass('hide');
    showStripe = true;
  }

  // stripe time start
  // Newly added code end   
  var sale_countDownDate = (theme.offer_end_date) * 1000;
  // var totalhours = 48;
  // Update the count down every 1 second
  var sale_msec = 1; // newly added
  var sale_sec_timer = null; // newly added
  var sale_now = new Date().getTime();
  // Find the distance between now and the count down date
  var sale_distance = (sale_countDownDate - sale_now);
  // console.log(sale_distance > 0 && showStripe);
  if (sale_distance > 0 && showStripe) {
    $('.offer-end-wrap').removeClass('hide');
    $('.top-header').addClass('mobile-red-bg');
    $('.shop-now-link-text').addClass('hide');
    var sale_x = setInterval(function() {
      // Get today's date and time
      var sale_now = new Date().getTime();
      // Find the distance between now and the count down date
      var sale_distance = (sale_countDownDate - sale_now);

      // Time calculations for days, hours, minutes and seconds
      var sale_days = Math.floor(sale_distance / (1000 * 60 * 60 * 24));
      var sale_hours = Math.floor((sale_distance % (1000 * 60 * 60 * 48)) / (1000 * 60 * 60));
      var sale_minutes = Math.floor((sale_distance % (1000 * 60 * 60)) / (1000 * 60));
      var sale_seconds = Math.floor((sale_distance % (1000 * 60)) / 1000);
      // var mseconds = Math.floor((distance / 1000).toFixed(3));
      // Display the result in the element with id="demo"
      if ($("#timer_second").is(":visible") == true)
        document.getElementById("timer_second").innerHTML = sale_hours.pad() + ":" +
        sale_minutes.pad() + ":" + sale_seconds.pad();

      // newly added code start
      if (!sale_sec_timer) {
        sale_msec = sale_seconds * 1000;
        sale_sec_timer = setInterval(function() {

          sale_msec -= 100;
        }, 100)
      }
      if (sale_seconds === 0) {
        clearInterval(sale_sec_timer);
        sale_sec_timer = null;
      }

      // If the count down is finished, write some text
      if (sale_distance < 0) {
        clearInterval(sale_x);
        clearInterval(sale_sec_timer);
        sale_sec_timer = null;
        if ($("#timer_second").is(":visible") == true) {
          $('.offer-end-wrap').addClass('hide');
          $('.shop-now-link-text').removeClass('hide');
          document.getElementById("timer_second").innerHTML = "OFFER END";
          window.location.reload();
        }

      }
    }, 1000);
  } else {
    $('.offer-end-wrap').addClass('hide');
    $('.top-header').removeClass('mobile-red-bg');
    $('.shop-now-link-text').removeClass('hide');
  }

  // stripe time end

});
// timer end

